<template>
  <router-link :class="$options.name" :to="path" v-if="path">
    <section :class="$options.name + '__label'">{{ label }}</section>
    <section v-if="icon" :class="$options.name + '__icon'">
      <Icon :name="icon" :size="14"/>
    </section>
  </router-link>
  <button
    :class="[
      $options.name,
      disabled ? $options.name + '--disabled':''
    ]"
    :disabled="disabled"
    v-else
  >
    <section :class="$options.name + '__label'">{{ label }}</section>
    <section v-if="icon" :class="$options.name + '__icon'">
      <Icon :name="icon" :size="14"/>
    </section>
  </button>
</template>
<script>
import Icon from "@/components/Icon";
export default {
  name: "Button",
  components: { Icon },
  props: {
    disabled: { default: false },
    icon: { default: "arrow-right" },
    label: { default: "Button label" },
    path: { default: null }
  }
};
</script>
<style lang="scss">
.Button {
  @include smooth;
  align-items: center;
  background-color: var(--base);
  border: rem(1) solid var(--base-mid);
  border-radius: rem(20);
  color: var(--contrast);
  display: inline-flex;
  height: rem(40);
  padding: 0 rem(16);
  width: auto;
  [data-theme="dark"] & {
    background-color: var(--contrast);
  }
  &:focus,
  &:hover {
    box-shadow: 0 rem(8) rem(16) rem(-8) rgba(black, 0.5);
    transform: scale(1.0125);
  }
  &--disabled {
    cursor: not-allowed;
    opacity: 0.75;
    &:focus,
    &:hover {
      box-shadow: none;
      transform: none;
    }
  }
  &__label {
    @include typeSize(m, l);
    color: white;
  }
  &__icon {
    align-items: center;
    color: var(--highlight);
    display: inline-flex;
    justify-content: center;
    margin-left: rem(8);
  }
}
</style>